import { useEffect } from 'react';

// issue #151: SPA 各ルートのブラウザタブタイトルを「おまかせ運指くん」系に統一する。
// React Router は document.title を触らないため、ページ側でこのフックを呼んで設定する。
export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
